import {
	CLEAR_PRODUCT_PAGE,
	FETCH_FICHE_PRODUIT_FAILURE,
	FETCH_FICHE_PRODUIT_REQUEST,
	FETCH_FICHE_PRODUIT_SUCCESS,
	RESTORE_BOOKING_SESSION_REQUEST,
	RESTORE_BOOKING_SESSION_SUCCESS,
} from "app/actionTypes";
import {
	computedProductTripadvisor,
	getDuration,
	mapProductResponseToState,
} from "app/utils/utils";
import {
	FETCH_SDP_ACCOMMODATION_DESCRIPTION_SUCCESS,
	FETCH_SDP_QUOTE_REQUEST,
	SAVE_SELECTED_SDP_PRODUCT,
} from "app/pages/SmartDP/smartDPActionTypes";
import { PRODUCT_PAGE_CODE_STATUS, REVIEW_PROVIDER } from "app/constants";
import {
	FETCH_STOPOVER_ACCOMMODATION_DESCRIPTION_REQUEST,
	FETCH_STOPOVER_ACCOMMODATION_DESCRIPTION_SUCCESS,
} from "app/pages/Stopover/stopoverActionTypes";
import {
	FETCH_DISTRIBUTIONS_REQUEST,
	FETCH_DISTRIBUTIONS_SUCCESS,
	FETCH_HOTEL_ONLY_ACCOMMODATION_DESCRIPTION_REQUEST,
	FETCH_HOTEL_ONLY_ACCOMMODATION_DESCRIPTION_SUCCESS,
} from "app/pages/HotelOnly/Booking/pages/Quote/BookingQuoteActionCreator";

const initialProductState = {
	status: PRODUCT_PAGE_CODE_STATUS.LOADING,
	id: "",
	photos: [],
	multimedia: [],
	highlights: [],
	name: "",
	adultOnly: false,
	isChildAgeRequired: false,
	category: 0,
	contractType: "",
	country: "",
	boards: [],
	region: "",
	badges: [],
	merchandisings: [],
	resort: "",
	specialOffer: {},
	tripAdvisor: {
		ratingURL: undefined,
		awardURL: undefined,
		rating: 0,
		reviewsCount: undefined,
		id: undefined,
	},
	expiration: {
		hour: undefined,
		day: undefined,
	},
	fromPriceType: {
		type: undefined,
		value: undefined,
	},
	expert: {
		loves: [],
	},
	accommodation: {
		intro: {
			headline: "",
			intro: [],
			facilities: [],
		},
		type: {
			headline: "",
			paragraphs: [],
			photo: {
				alt: "",
				url: "",
				thumbnail: "",
			},
			accommodationTypes: [],
			facilities: [],
		},
	},
	restaurant: {
		headline: "",
		intro: [],
		restaurants: [],
		facilities: [],
	},
	transportPartnership: {
		label: "",
		photo: {
			alt: "",
			url: "",
			thumbnail: "",
		},
		paragraphs: [],
	},
	gps: {},
	destination: {},
	experiences: [],
	highlightedExtra: {
		headline: "",
		subheading: "",
		highlightedExtras: [],
	},
	activity: {},
	usefulInformations: {},
	included: {},
	notIncluded: {},
	notFound: false,
};

export default function ficheProduitReducer(ficheProduit = initialProductState, action) {
	switch (action.type) {
		case FETCH_HOTEL_ONLY_ACCOMMODATION_DESCRIPTION_REQUEST:
		case FETCH_DISTRIBUTIONS_REQUEST:
		case RESTORE_BOOKING_SESSION_REQUEST:
		case FETCH_STOPOVER_ACCOMMODATION_DESCRIPTION_REQUEST:
		case FETCH_SDP_QUOTE_REQUEST:
		case CLEAR_PRODUCT_PAGE:
			return initialProductState;
		case FETCH_STOPOVER_ACCOMMODATION_DESCRIPTION_SUCCESS:
		case FETCH_SDP_ACCOMMODATION_DESCRIPTION_SUCCESS: {
			const product = action.res.data || {};

			if (product.endAt) {
				const now = new Date();
				const duration = getDuration(now.getTime(), product.endAt);
				product.expiration = duration;
			}

			if (product.tripadvisor) {
				product.tripAdvisor = computedProductTripadvisor(product.tripadvisor);
			}

			if (product.status === PRODUCT_PAGE_CODE_STATUS.SESSION_EXPIRED) {
				return {
					...product,
					status: PRODUCT_PAGE_CODE_STATUS.SESSION_EXPIRED,
				};
			}
			return {
				...product,
				status: PRODUCT_PAGE_CODE_STATUS.SUCCESS,
			};
		}
		case FETCH_HOTEL_ONLY_ACCOMMODATION_DESCRIPTION_SUCCESS:
		case FETCH_DISTRIBUTIONS_SUCCESS: {
			const data = action?.res?.data;
			const product = data?.accommodation?.description || {};

			if (product.endAt) {
				const now = new Date();
				const duration = getDuration(now.getTime(), product.endAt);
				product.expiration = duration;
			}

			const tripAdvisorReview = product.reviews?.[REVIEW_PROVIDER.TRIP_ADVISOR];
			if (tripAdvisorReview) {
				product.tripAdvisor = computedProductTripadvisor(tripAdvisorReview);
			}

			const coordinates = product?.geography?.geometry?.coordinates;
			if (coordinates) {
				product.gps = {
					lat: coordinates[1],
					lon: coordinates[0],
				};
			}

			if (product.status === PRODUCT_PAGE_CODE_STATUS.SESSION_EXPIRED) {
				return {
					...product,
					status: PRODUCT_PAGE_CODE_STATUS.SESSION_EXPIRED,
				};
			}

			return {
				...product,
				id: data?.accommodation?.id,
				name: data?.accommodation?.name,
				category: data?.accommodation?.rating,
				status: PRODUCT_PAGE_CODE_STATUS.SUCCESS,
			};
		}
		case SAVE_SELECTED_SDP_PRODUCT: {
			return action.accommodation;
		}
		case RESTORE_BOOKING_SESSION_SUCCESS: {
			const { quoteRequest = {}, ...rest } = action.res.data;
			return {
				id: quoteRequest.productId,
				uri: rest.productUri,
			};
		}
		case FETCH_FICHE_PRODUIT_REQUEST: {
			return {
				...ficheProduit,
				status: PRODUCT_PAGE_CODE_STATUS.LOADING,
			};
		}
		case FETCH_FICHE_PRODUIT_SUCCESS: {
			return mapProductResponseToState({ ...initialProductState, ...action.res.data });
		}
		case FETCH_FICHE_PRODUIT_FAILURE: {
			return Object.assign({}, initialProductState, { notFound: true });
		}

		default:
			return ficheProduit;
	}
}
